import React, { FC } from 'react';

import { PageHeaderProps } from '@ant-design/pro-layout';

import { Header, Title, SubHeader } from './styled';

const PageHeader: FC<Props> = props => {
  const { title, subHeader, ...rest } = props;

  return (
    <>
      <Header ghost={false} title={<Title level={3}>{title}</Title>} {...rest} />
      {subHeader && <SubHeader>{subHeader}</SubHeader>}
    </>
  );
};

export { PageHeader };

interface Props extends PageHeaderProps {
  title: string | JSX.Element;
  subHeader?: JSX.Element;
  extra?: React.ReactNode;
}
